import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ArtistState } from "explorer/reducers/artistas";
import ShimmerSkeleton from "shared/components/skeleton";
import "./ArtistFeatureCard.scss";

interface ArtistFeatureCardProps {
  title: string;
  subtitle: string;
  image: string;
  isPageInfo?: boolean;
}

export const ArtistFeatureCard: React.FC<ArtistFeatureCardProps> = ({
  isPageInfo = false,
  title,
  subtitle,
  image,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { userArtist } = useSelector((state: ArtistState) => state.artists);

  const level = userArtist.stage || 0;
  const { titulo } = t(`pages.EstagioArtista.estagio.${level}`) as any;
  const { titulo: tituloProximo } = t(
    `pages.EstagioArtista.estagio.${level + 1}`,
  ) as any;

  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!userArtist?.profileImage) return;
    const img = new Image();
    img.onload = () => setImageLoaded(true);
    img.src = userArtist.profileImage;
  }, [userArtist?.profileImage]);

  return (
    <div className="artist-feature-card">
      {isPageInfo && (
        <div className="page-title">
          <span className="title">
            <img src={image} alt="" />
            <span>{title}</span>
          </span>
          <span className="subtitle">{subtitle}</span>{" "}
        </div>
      )}
      <div
        onClick={() => history.push("/estagio")}
        style={{ cursor: "pointer" }}
        className="f-card"
      >
        {!imageLoaded && (
          <ShimmerSkeleton height={352} borderRadius={12} />
        )}
        <div
          className="artist-feature-card-bg"
          style={{
            backgroundImage: `url(${userArtist?.profileImage || ""})`,
            display: imageLoaded ? undefined : "none",
          }}
        >
          <div className="level-badge">
            <BadgeStage stage={userArtist?.stage || 0} />
            <span className="level-label-text">{titulo}</span>
          </div>

          <div className="card-content">
            <div className="welcome-label">{t("pages.Home.welcomeTitle")}</div>
            <div className="artist-name heading-h4">{userArtist?.name}</div>
            {level < 10 && (
              <div className="next-level">
                <span className="next-level-label">
                  {t("pages.Home.nextLevel")} :{" "}
                </span>
                <b style={{ opacity: 1 }}>{tituloProximo}</b>
              </div>
            )}

            <div className="progress-row">
              <div className="progress-track" aria-hidden>
                <div
                  className="progress-filled"
                  style={{
                    width: `${userArtist?.stagePercentual || 0}%`,
                  }}
                />
              </div>

              <div
                className="percent-pill"
                style={{
                  left: `calc(${userArtist?.stagePercentual || 0}% - 16px)`,
                }}
              >
                {(userArtist?.stagePercentual || 0).toFixed(0)}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const BadgeStage: React.FC<{ stage: number }> = ({ stage }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <path
        d="M7.11276 0.679505C8.47728 -0.226894 10.2522 -0.226894 11.6167 0.679505L16.5409 3.95043C17.6013 4.65485 18.2711 5.81488 18.3509 7.08546L18.7215 12.9854C18.8242 14.6203 17.9368 16.1574 16.4695 16.8859L11.1748 19.5149C10.0345 20.0811 8.695 20.0811 7.55474 19.5149L2.25996 16.8859C0.792733 16.1574 -0.0947347 14.6203 0.00797093 12.9854L0.378606 7.08546C0.458424 5.81488 1.12817 4.65485 2.18861 3.95043L7.11276 0.679505Z"
        fill="#F2F2F2"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#1A1A1A"
        fontSize="12"
      >
        {stage}
      </text>
    </svg>
  );
};
